import { call, put, select, takeLatest } from "redux-saga/effects";
import qs from 'qs';
import { FETCH_NEXT_STEP_CARD_REQUEST, fetchNextStepCardFailure, fetchNextStepCardSuccess } from "../../actions/opportunities/nextStepCardActions";
import iq_api_v2 from "../../../../services/iqApiV2";


async function findNextStepCardData(opportunityId) {
    const data = qs.stringify({
      opportunity_id: opportunityId,
    });
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post("/opportunities/get_next_steps?"+data, '')
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchNextStepCardSaga() {
  try {
    const payload = yield select(
      (state) => state?.nextStepCardReducer?.payload
    );
    const { opportunityId="" } = payload;
    const data = yield call(
        findNextStepCardData,
        opportunityId
    );
    yield put(fetchNextStepCardSuccess(data?.[0]));
  } catch (error) {
    yield put(fetchNextStepCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchNextStepCardData() {
  yield takeLatest(FETCH_NEXT_STEP_CARD_REQUEST, fetchNextStepCardSaga);
}
